<div class="support-hub-page">
  <div class="hub-toolbar">
    <div class="hub-toolbar-left">
      <nav class="hub-nav">
        <a routerLink="dashboard" [queryParams]="getNavQueryParams()" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="hub-nav-link">Dashboard</a>
        <a routerLink="all-tickets" [queryParams]="getNavQueryParams()" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="hub-nav-link">All Tickets</a>
        <a routerLink="new-ticket" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="hub-nav-link">New Ticket</a>
        <a routerLink="version" [queryParams]="getNavQueryParams()" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="hub-nav-link">Version</a>
        @if (currentUserRole$ | async; as navRole) {
          @if (isAdminRole(navRole)) {
            <a routerLink="release" [queryParams]="getNavQueryParams()" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="hub-nav-link">Release</a>
            <a routerLink="role-assignment" [queryParams]="getNavQueryParams()" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="hub-nav-link">Role Assignment</a>
          }
        }
      </nav>
    </div>
    <div class="hub-toolbar-right">
      <div class="role-switcher-wrap" aria-label="Support Hub Use Case Switcher">
        <label class="role-switcher-label" for="support-hub-usecase-select">Use case</label>
        <select class="role-select usecase-select" id="support-hub-usecase-select" [(ngModel)]="selectedUseCaseId"
          (ngModelChange)="onUseCaseDropdownChange($event)" [disabled]="disableusecaseSelect">
          @for (useCase of useCaseOptions; track useCase.id) {
            <option [ngValue]="useCase.id">{{ useCase.name }}</option>
          }
        </select>
      </div>
      <div class="role-switcher-wrap" aria-label="Support Hub Role Switcher" [hidden]="hideViewAsOption">
        <label class="role-switcher-label" for="support-hub-role-select">View as</label>
        <select class="role-select" id="support-hub-role-select" [(ngModel)]="selectedRole" 
          (ngModelChange)="onRoleDropdownChange($event)">
          @for (roleOption of roleOptions; track roleOption) {
            <option [ngValue]="roleOption">{{ roleOption }}</option>
          }
        </select>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>